import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  button: 'data-btn',
  saleBtn: 'data-sale',
}
const qsAll = {
  sections: 'data-section-type="shop-by-color"',
  saleItems: 'data-sale-item',
  items: 'data-item',
}

export const setupShopByColor = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    const items = section.querySelectorAll(`[${qsAll.items}]`)
    const saleItems = section.querySelectorAll(`[${qsAll.saleItems}]`)

    const button = section.querySelector(`[${qs.button}]`)
    const saleBtn = section.querySelector(`[${qs.saleBtn}]`)
    button.addEventListener('click', () => {
      button.closest('.shop-by-color--group__head').classList.toggle('shop-by-color--group__active')

      if(saleBtn) saleBtn.classList.add('lg:opacity-50', 'lg:hover:opacity-100')
      button.classList.remove('lg:opacity-50', 'lg:hover:opacity-100')

      items.forEach((item) => {
        item.classList.add('block')
        item.classList.remove('hidden')
      })
      saleItems.forEach((saleItem) => {
        saleItem.classList.remove('block')
        saleItem.classList.add('hidden')
      })
    })

    if(saleBtn) {
      saleBtn.addEventListener('click', () => {
        saleBtn.classList.remove('lg:opacity-50', 'lg:hover:opacity-100')
        button.classList.add('lg:opacity-50', 'lg:hover:opacity-100')
        items.forEach((item) => {
          item.classList.add('hidden')
          item.classList.remove('block')
        })
        saleItems.forEach((saleItem) => {
          saleItem.classList.remove('hidden')
          saleItem.classList.add('block')
        })
      })
    }
  })
}